(() => {
  if (customElements.get('cosfaire-costume-tabs')) return;

  class CosfaireCostumeTabs extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const tablist = this.querySelector('[data-tabs]');
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      if (!tablist || !this.tabs.length || this.tabs.length !== this.panels.length) return;
      this.initialized = true;
      tablist.setAttribute('role', 'tablist');
      this.panels.forEach(panel => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('tabindex', '0');
      });
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', tab.dataset.tab);
        tab.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
          event.preventDefault();
          this.select(index);
        });
        tab.addEventListener('keydown', event => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else if (event.key !== ' ') return;
          event.preventDefault();
          this.select(next);
          this.tabs[next].focus();
        });
      });
      this.select(0);
    }

    select(index) {
      this.tabs.forEach((tab, tabIndex) => {
        const selected = tabIndex === index;
        tab.classList.toggle('is-selected', selected);
        tab.setAttribute('aria-selected', String(selected));
        tab.setAttribute('tabindex', selected ? '0' : '-1');
        this.panels[tabIndex].hidden = !selected;
      });
    }
  }

  customElements.define('cosfaire-costume-tabs', CosfaireCostumeTabs);
})();
